import { SIZE } from '../settings/constants';
import { getSizeData, ResizeData } from './ResizeData';

export default class Resizer {
  winW: number;
  winH: number;
  resizeCall: signals.Signal;
  currentData?: ResizeData;

  constructor(resizeCall: signals.Signal) {
    // vars
    this.winW = 0;
    this.winH = 0;

    this.resizeCall = resizeCall;

    // init
    this.init();
  }

  init(): void {
    this.initResolution();
    // listener
    window.addEventListener('resize', () => {
      this.resizeUpdate();
    });
    // init update
    this.resizeUpdate();
    // delayed resizes - mainly because of iOS delay
    setTimeout(() => {
      this.resizeUpdate();
    }, 500);
    setTimeout(() => {
      this.resizeUpdate();
    }, 1500);
  }

  initResolution(): void {
    // Set mobile page scale to prevent blurred canvas content (inspired/simplified Advent solution)
    const winW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const winH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const viewport = document.getElementById('viewport');
    if (viewport) {
      const scale = Math.min(winW / SIZE.W, winH / SIZE.H);
      viewport.setAttribute(
        'content',
        `width=device-width, initial-scale=${scale}, maximum-scale=${scale}, user-scalable=no, minimal-ui`,
      );
    }
  }

  resizeUpdate(): void {
    const lastW = this.winW;
    const lastH = this.winH;
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;

    // skip when nothing changed
    if (lastW === this.winW && lastH === this.winH) {
      return;
    }
    this.appResize(getSizeData());
  }

  appResize(data: ResizeData): void {
    // dispatch update
    this.resizeCall.dispatch(data);
  }
}
